<template>
  <d-form>
    <d-form-row class="form-group">
      <d-col cols="12" md="10">
        <label>Texto:</label>
        <div>
          <editor
            :model.sync="model.text"
            ref="editor"
            reference="text"
            @ready="setQuill"
            :editorOption="{modules: {
              toolbar: null,
              keyboard: {
                bindings: {
                  bold: {
                    key: 'B',
                    shortKey: true,
                    handler: selectWord
                  },
                }
              }
            }}"
          />
        </div>
      </d-col>
      <d-col cols="12" md="2" class="d-flex flex-column">
        <d-row class="h-100 pb-1">
          <d-col cols="12">
            <label>Selecionadas:</label>
            <d-input class="form-control" v-model="model.list.length" readonly />
          </d-col>

          <d-col cols="12" class="d-flex flex-column justify-content-between">
            <div>
              <d-checkbox
                toggle
                v-model="model.enableSubWord"
                class="custom-toggle-sm mt-2"
              >
                Evitar palavra e sub-palavra
              </d-checkbox>
            </div>
            <div class="d-flex flex-column">
              <d-button type="button" class="mt-1 btn" @click="generateResult">Gerar</d-button>
              <d-button type="button" class="mt-1 btn btn-danger" @click="cleanText">Limpar</d-button>
              <d-button type="button" class="mt-1 btn btn-success" @click="download">Baixar</d-button>
            </div>
          </d-col>
        </d-row>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group">
      <d-col cols="12" md="4">
        <label>Lista:</label>
        <ol class="pl-3">
          <li class="cursor-pointer" v-for="(word, index) in getPlacedWords()" :key="word" @click="removeWord(index)">{{word}}</li>
        </ol>
      </d-col>
      <d-col cols="12" md="8">
        <label>Texto gerado:</label>
        <editor :model.sync="model.result" reference="result" :editorOption="{modules: { toolbar: null }}" />
        <div class="w-100 text-center my-2" v-if="model.list.length">
          <GameStatusAndPopover
            :placedWords="getPlacedWords()"
            :wordsList="model.list"
            :index="1"
            title="Palavras selecionadas"
            description="selecionadas"
          />
        </div>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import GameStatusAndPopover from '_shared/GameStatusAndPopover.vue';
import { filterWordsToAvoidSubWords } from '_utils';
import htmlToRtf from 'html-to-rtf';

export default {
  name: 'generate-form',
  components: {
    Editor,
    GameStatusAndPopover,
  },
  data() {
    return {
      timer: null,
      quill: null,
      model: {
        text: '',
        list: [],
        result: '',
        enableSubWord: false,
      },
    };
  },
  methods: {
    ...mapActions(['activeAlert']),
    getPlacedWords() {
      const list = [...this.model.list];

      return this.model.enableSubWord
        ? filterWordsToAvoidSubWords(list)
        : list;
    },
    cleanText() {
      this.model.text = '';
      this.model.list = [];
    },
    setQuill(quill) {
      this.quill = quill;
    },
    replaceWithFormatted(index, length, formatted) {
      const options = [];

      if (index > 0) {
        options.push({ retain: index });
      }

      options.push({ delete: length });
      options.push({ insert: formatted });

      this.quill.updateContents({ ops: options });
      this.quill.formatText(index, formatted.length, 'bold', true);
    },
    getWordRange(range) {
      const word = this.quill.getText(range.index, range.length);
      const trimStart = word.length - word.trimStart().length;
      const trimEnd = word.length - word.trimEnd().length;
      return {
        index: range.index + trimStart,
        length: range.length - trimStart - trimEnd,
        text: word.trim(),
      };
    },
    selectWord(range) {
      const { index, length, text } = this.getWordRange(range);
      const wordUppercase = text.toUpperCase().replace(/\*/g, '');
      const formatted = `**${wordUppercase}**`;

      if (!wordUppercase) return;

      if (this.model.list.includes(wordUppercase)) {
        this.activeAlert({ message: `Palavra repetida! ${wordUppercase}`, theme: 'warning' });
        return;
      }

      this.model.list = [...this.model.list, wordUppercase];
      this.replaceWithFormatted(index, length, formatted);
    },
    removeWord(index) {
      const placedWords = this.getPlacedWords();
      const word = placedWords[index];

      const listIndex = this.model.list.indexOf(word);

      if (listIndex > -1) {
        this.model.list.splice(listIndex, 1);
      }

      this.model.text = this.model.text.replace(
        `<strong>**${word}**</strong>`,
        word.toLowerCase(),
      );
    },
    generateResult() {
      const placedWords = this.getPlacedWords();

      this.model.result += this.model.text;
      this.model.result += '<p><br></p>';
      this.model.result += placedWords.join('<br>');
      this.model.result += '<p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>';
    },
    download() {
      const c = document.createElement('a');
      c.download = 'texto-gerado.rtf';
      let text = htmlToRtf.convertHtmlToRtf(this.model.result);
      text = text.replaceAll(/\s}\s/g, ' }');
      text = text.replaceAll(/'93 {/g, item => item.replace(' ', ''));
      text = text.replaceAll(/\s}[,.;:!?`'"\\'94]/g, item => item.substr(1));
      const t = new Blob([text], {
        type: 'text/plain',
      });
      c.href = window.URL.createObjectURL(t);
      c.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
  &:hover {
    color: red;
  }
}
.text-area {
  height: 200px;
}
</style>
